/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class DlsgSettings {
  /**
  * Whether dlsg client-side deployment is enabled for resource associated with this policy.
  */
  'enableClientSideDeployment': boolean;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "enableClientSideDeployment",
      "baseName": "enableClientSideDeployment",
      "type": "boolean",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return DlsgSettings.attributeTypeMap;
  }

  public constructor() {
  }
}

